import { Expose } from 'class-transformer';

export class GetLocationExtraInformationDto {
  @Expose({ name: 'restaurant_link' })
  restaurantLink: string;
  @Expose({ name: 'rent_map_link' })
  rentMapLink: string;
  @Expose({ name: 'parking_link' })
  parkingLink: string;
}
